module.exports = __webpack_public_path__ + "static/img_5088-18bceb8a52a9603c27bfc894847440ec.webp";